import { defineMessages } from "react-intl";

export const columnsMessages = defineMessages({
  name: {
    id: "eLJQSh",
    defaultMessage: "Gift Card",
    description: "column title gift card",
  },
  status: {
    id: "tzMNF3",
    defaultMessage: "Status",
  },
  tag: {
    id: "FEWgh/",
    defaultMessage: "Tag",
    description: "column title tag",
  },
  productTitle: {
    id: "bwJc6V",
    defaultMessage: "Product",
    description: "column title product",
  },
  customer: {
    id: "MJBAqv",
    defaultMessage: "Used by",
    description: "column title used by/customer",
  },
  balance: {
    id: "MbZHXE",
    defaultMessage: "Balance",
    description: "column title balance",
  },
});

export const messages = defineMessages({
  codeEndingWithLabel: {
    id: "38dS1A",
    defaultMessage: "Code ending with {last4CodeChars}",
    description: "code ending with label",
  },
  noData: {
    id: "Rd0s80",
    defaultMessage: "No gift cards found",
    description: "no cards found title message",
  },
  active: {
    defaultMessage: "Active",
    id: "3a5wL8",
  },
});
